<admin-panel-configurable [title]="'Labels'">
  <admin-table-standard [items]="labelValues!">
    <ng-template #header>
      <th class="col-md-3" scope="col">{{ 'pages.channels.view.labels.value' | translate }}</th>
      <th class="col-md-9" scope="col">{{ 'pages.channels.view.labels.condition' | translate }}</th>
    </ng-template>
    <ng-template #first let-item>
      <td>{{ item.value }}</td>
      <td>{{ item.condition | json }}</td>
    </ng-template>
  </admin-table-standard>
</admin-panel-configurable>
